import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BrandButton } from "components/brand";

import {
  login,
  //TODO open 2fa after deploy.
  // setup2FA,
  // verify2FA,
  // verify2FALogin,
  // clear2FAError,
  // clear2FASetup,
} from "features/auth";
//TODO open 2fa after deploy.
// import { TwoFAModal } from "components/TwoFactorAuth";

import {
  InputAdornment,
  FormControlLabel,
  Checkbox,
  TextField,
  Box,
  IconButton,
} from "@mui/material";
import {
  MailOutlineTwoTone,
  LockTwoTone,
  VisibilityOff,
  Visibility,
} from "@mui/icons-material";
import { LOGIN_PAGE, CONSTANTS, REQUEST_STATUSES } from "constants/general";

import "react-toastify/dist/ReactToastify.css";

import logo from "assets/images/sidebarHeader/larochelle-logo.png";

export default function LivePreviewExample() {
  const [rem, setRem] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  //TODO open 2fa after deploy.
  // const [userEmail, setUserEmail] = useState("");
  const { status } = useSelector((state) => state.auth);
  //TODO open 2fa after deploy.
  // const { status, twoFA } = useSelector((state) => state.auth);

  const isLoading = status === REQUEST_STATUSES.loading;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
    rem: rem,
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(CONSTANTS.EMAIL_VALIDATION_MESSAGE),
    password: Yup.string().required(CONSTANTS.INVALID_PASSWORD_MESSAGE),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      //TODO open 2fa after deploy.
      // setUserEmail(values.email);
      dispatch(
        login({
          email: values.email,
          password: values.password,
          rem,
        }),
      );
    },
  });

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  //TODO open 2fa after deploy.
  // const handle2FASetupComplete = () => {
  //   dispatch(clear2FASetup());
  //   navigate("/");
  // };

  // const handle2FAVerification = (code) => {
  //   const hasQRCode = !!twoFA.setupData?.qrCodeUrl;

  //   if (hasQRCode && !twoFA.is2FAEnabled) {
  //     dispatch(verify2FA({ email: userEmail, token: code }));
  //   } else {
  //     dispatch(verify2FALogin({ email: userEmail, token: code }));
  //   }
  // };

  // const handle2FAModalClose = () => {
  //   dispatch(clear2FAError());
  //   dispatch(clear2FASetup());
  // };

  useEffect(() => {
    //TODO open 2fa after deploy.
    // Navigate directly after successful login (no 2FA)
    if (status === REQUEST_STATUSES.solved) {
      navigate("/");
    }
    // if (status === REQUEST_STATUSES.solved && !twoFA.requires2FA) {
    //   navigate("/");
    // }
  }, [status, navigate]);

  //TODO open 2fa after deploy.
  // useEffect(() => {
  //   if (
  //     twoFA.requires2FA &&
  //     !twoFA.is2FAEnabled &&
  //     !twoFA.setupData &&
  //     userEmail
  //   ) {
  //     dispatch(setup2FA({ email: userEmail }));
  //   }
  // }, [
  //   twoFA.requires2FA,
  //   twoFA.is2FAEnabled,
  //   twoFA.setupData,
  //   userEmail,
  //   dispatch,
  // ]);

  return (
    <>
      {/* TODO open 2fa after deploy. */}
      {/* <TwoFAModal
        open={twoFA.requires2FA}
        onClose={handle2FAModalClose}
        onVerify={handle2FAVerification}
        onComplete={handle2FASetupComplete}
        isLoading={isLoading}
        error={twoFA.verificationError}
        email={userEmail}
        is2FAEnabled={twoFA.is2FAEnabled}
        qrCodeUrl={twoFA.setupData?.qrCodeUrl}
        secret={twoFA.setupData?.secret}
        backupCodes={twoFA.setupData?.backupCodes}
      /> */}

      <div className="app-wrapper min-vh-100 bg-white">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-inner-content-layout--main">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content">
                  <div className="login_page">
                    <div className="login_field_container">
                      <div>
                        <div className="logo_filed">
                          <img
                            src={logo}
                            alt="Property vision"
                            className="login_logo"
                          />
                        </div>
                        <div className="text_filed">
                          <p className="welcome_text">{LOGIN_PAGE.welcome}</p>
                          <p className="signin_text">
                            {LOGIN_PAGE.sign_in_text}
                          </p>
                        </div>
                        <Box component="form" onSubmit={formik.handleSubmit}>
                          <div className="mb-4">
                            <TextField
                              fullWidth
                              variant="outlined"
                              name="email"
                              placeholder={LOGIN_PAGE.email_address}
                              autoComplete="true"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.email && formik.errors.email
                              }
                              helperText={
                                formik.touched.email &&
                                formik.errors.email &&
                                CONSTANTS.EMAIL_VALIDATION_MESSAGE
                              }
                              InputProps={{
                                required: true,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <MailOutlineTwoTone />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <TextField
                              fullWidth
                              variant="outlined"
                              name="password"
                              placeholder={LOGIN_PAGE.password}
                              type={showPassword ? "text" : "password"}
                              value={formik.values.password}
                              autoComplete="true"
                              onChange={formik.handleChange}
                              error={
                                formik.touched.password &&
                                formik.errors.password
                              }
                              helperText={
                                formik.touched.password &&
                                formik.errors.password &&
                                CONSTANTS.INVALID_PASSWORD_MESSAGE
                              }
                              InputProps={{
                                required: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                    >
                                      {showPassword ? (
                                        <VisibilityOff />
                                      ) : (
                                        <Visibility />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <LockTwoTone />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                          <div className="d-flex justify-content-between align-items-center font-size-md">
                            <FormControlLabel
                              className="login_checkbox"
                              control={
                                <Checkbox
                                  checked={rem}
                                  onChange={(e) => setRem(!rem)}
                                  value="checked1"
                                />
                              }
                              label={LOGIN_PAGE.remember_me}
                            />
                          </div>
                          <div className="text-center py-4">
                            <BrandButton
                              type="submit"
                              variant="primary"
                              className="btn-login"
                              disabled={isLoading}
                            >
                              {LOGIN_PAGE.sign_in}
                            </BrandButton>
                          </div>
                        </Box>
                      </div>
                    </div>
                    <div className="login_image_field"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
